export const BranchioEvents = Object.freeze({
  COMPLETE_REGISTRATION: 'COMPLETE_REGISTRATION',
  SUBSCRIBE: 'SUBSCRIBE',
} as const);

export const CustomerEventAliasValues = Object.freeze({
  TRIAL: 'Trial',
  SUBSCRIBE: 'Subscribe',
} as const);
